import React from 'react';
import PropTypes from 'prop-types';

class ResendProgress extends React.Component {

	render() {
		return (
			<div className="resend-status">
				{this.props.intl('Осталось отправить')} {this.props.resendPostbacksLeft}
				<p>{this.props.resendPostbacksTotal} {this.props.intl('постбеков отправится')}</p>
			</div>
		);
	}
}

ResendProgress.propTypes = {
	resendPostbacksLeft: PropTypes.func,
	intl: PropTypes.func
};

export default ResendProgress;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/global-postback/components/resendProgress.js